import LogomarcaCommercialEdition from '../../assets/images/logomarca-commercial-edition1.png';

const CommercialEdition = () => {
    return (
        <section id="commercial-edition">
            <div className="titulo">
                <div className="container px-5">
                    <div className='row justify-content-center mb-2'>
                        <div className="col-12 col-md-10">
                            <img
                                src={LogomarcaCommercialEdition}
                                width='20%'
                                className='img-fluid'
                                alt="Lideres do Sucesso Commercial Edition"
                            />
                        </div>
                    </div>

                    <div className='row justify-content-center'>
                        <div className="col-12 col-md-10">
                            <h4 className='text-white'>Confira como foi nossa última edição <span style={{color:'#f89e32'}}>2022</span></h4>
                        </div>
                    </div>

                    <div className='row justify-content-center mt-5'>
                        <div className="col-12 col-md-10">
                            <iframe
                                width="100%"
                                src="https://www.youtube.com/embed/p0LnqP6_ClI?si=VWKI_RXaHmRMJW6X"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CommercialEdition;